/* eslint-disable react-hooks/rules-of-hooks */
'use client';
import React, { useMemo } from 'react';
import { ROUTES } from '@/constants/routes/default';
import Logo from '@/components/svgs/cn/logo';

import Link from 'next/link';
import { cn } from '@/helpers/common';
import { useSession, signOut } from 'next-auth/react';
import HeaderDropdownCN from './HeaderDropdownCN';
import { usePathname } from 'next/navigation';

const HeaderCN = ({ skipSession = false }: { skipSession?: boolean }) => {
  const pathname = usePathname();
  let session = null;
  if (!skipSession) {
    const { data: value } = useSession();
    session = value;
  }
  const options = useMemo(() => {
    let result = [];

    if (session) {
      result = [
        {
          type: 'link',
          title: 'My Jobs',
          href: ROUTES.myJobs,
          withDivider: true,
        },
        {
          type: 'link',
          title: 'My Account',
          href: ROUTES.profile,
          withDivider: false,
        },
        {
          type: 'link',
          title: 'Job Alerts',
          href: ROUTES.jobAlerts,
          withDivider: false,
        },
        { type: 'button', title: 'Sign out', onClick: () => signOut(), withDivider: true },
      ];
    } else {
      result = [
        {
          type: 'link',
          title: 'Login',
          href: ROUTES.signin,
          withDivider: false,
        },
        {
          type: 'link',
          title: 'Sign Up',
          href: ROUTES.signup,
          withDivider: false,
        },
      ];
    }

    return result;
  }, [!!session]);

  return (
    <header className="flex md:px-10 max-md:px-4 min-h-20 border-b border-black3">
      <div className="max-w-300 w-full h-full flex justify-between items-center m-auto flex-wrap gap-4">
        <Link href={ROUTES.home} aria-label="Canvas Nusring Logo">
          <Logo className="w-35 h-4 shrink-0" />
        </Link>
        {!session ? (
          <div className={'md:flex max-md:hidden gap-8 justify-center items-center'}>
            <a
              className="no-underline default-transition font-bold text-jelly-bean hover:text-black"
              href={ROUTES.signin}
            >
              Login
            </a>
            <a
              className={cn(
                'no-underline default-transition px-5 py-1.75 font-bold border rounded-lg',
                'text-jelly-bean hover:text-white border-jelly-bean hover:border-black hover:bg-black',
              )}
              href={ROUTES.signup}
            >
              Sign Up
            </a>
          </div>
        ) : (
          <>
            <div className={'md:flex max-md:hidden gap-6 justify-center items-center h-full'}>
              <div className="relative flex justify-center items-center h-full">
                <a
                  className={cn(
                    'flex justify-center items-center h-10 px-3 font-bold text-jelly-bean hover:text-black hover:bg-jelly-bean-light2 rounded-lg',
                    'no-underline default-transition',
                  )}
                  href={ROUTES.myJobs}
                >
                  My Jobs
                </a>
                {pathname === ROUTES.myJobs && (
                  <div className="absolute mt-4 -bottom-4.75 h-1 w-[calc(100%-24px)] rounded-t-sm bg-jelly-bean" />
                )}
              </div>
              <div className="relative flex justify-center items-center h-full">
                <a
                  className={cn(
                    'flex justify-center items-center h-10 px-3 font-bold text-jelly-bean hover:text-black hover:bg-jelly-bean-light2 rounded-lg',
                    'no-underline default-transition',
                  )}
                  href={ROUTES.profile}
                >
                  My Account
                </a>
                {pathname === ROUTES.profile && (
                  <div className="absolute mt-4 -bottom-4.75 h-1 w-[calc(100%-24px)] rounded-t-sm bg-jelly-bean" />
                )}
              </div>
              <div className="relative flex justify-center items-center h-full">
                <a
                  className={cn(
                    'flex justify-center items-center h-10 px-3 font-bold text-jelly-bean hover:text-black hover:bg-jelly-bean-light2 rounded-lg',
                    'no-underline default-transition',
                  )}
                  href={ROUTES.jobAlerts}
                >
                  Job Alerts
                </a>
                {pathname === ROUTES.jobAlerts && (
                  <div className="absolute mt-4 -bottom-4.75 h-1 w-[calc(100%-24px)] rounded-t-sm bg-jelly-bean" />
                )}
              </div>
            </div>
            <div className={'md:flex max-md:hidden justify-center items-center'}>
              <button
                className={cn(
                  'no-underline default-transition px-5 py-1.75 font-bold border rounded-lg',
                  'text-jelly-bean hover:text-white border-jelly-bean hover:border-black hover:bg-black',
                )}
                onClick={() => signOut()}
              >
                Sign out
              </button>
            </div>
          </>
        )}
        <div className="md:hidden max-md:block">
          <HeaderDropdownCN
            classNames={{
              listCn: 'max-w-50 right-0 bg-white py-3 rounded-lg custom-shadow-cn-2',
              elementCn: 'text-sm h-9 px-4 flex items-center hover:bg-jelly-bean-light2',
              rootCn: '',
              iconCn:
                'h-9 w-9 rounded-lg border-2 border-jelly-bean [&>svg>path]:fill-jelly-bean! hover:[&>svg>path]:fill-black! hover:border-black',
              activeIconCn: '[&>svg>path]:fill-black! border-black',
            }}
            isAuthorized={!!session}
            introviewUrl={''}
            isSighInPath={false}
            listHeader={
              session && session?.user?.email ? (
                <div
                  className={cn(
                    'text-xs overflow-hidden whitespace-nowrap text-ellipsis',
                    'px-3.5 py-2 text-dove-gray',
                  )}
                >
                  {session?.user?.email}
                </div>
              ) : null
            }
            customOptions={options}
          />
        </div>
      </div>
    </header>
  );
};

export default HeaderCN;
